var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"tag",class:_vm.className},[_c('span',{staticClass:"o-tag__inner"},[_c('span',{staticClass:"o-tag__label | t-caps -xs"},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }